module.exports = __webpack_public_path__ + "static/2-f9b27c7f86e533b590fe337fe2d8aa2b.jpg";